import styled from "styled-components";

import { MEDIA_QUERIES } from "context/media/MediaConstant";

// eslint-disable-next-line import/prefer-default-export
export const StyledOuterContainer = styled.div`
  padding-top: 16px;

  @media ${MEDIA_QUERIES.MOBILE} {
    margin-right: 0;
  }
`;
